import { defineStore } from 'pinia';
import { supportsSessionStorage } from '@/common';

const storageKey = "DRF-Subscription-Data";

export const useDataStore = defineStore('data', {
    state: () => ({
        supportsDialog: false,
        viewport: null,
        admin: false,
        accountId: null,
        countries: [],
        subscriptions: [],
        paymentMethods: [],
        publicKey: {
            loginId: null,
            clientKey: null,
        },
        dataid: null,
    }),
    actions: {
        setInitialData: function(data, doNotSave) {
            this.countries = data.countries;
            this.admin = !!data.admin;
            this.accountId = data.accountId || null;
            this.subscriptions = data.subscriptions;
            this.paymentMethods = data.paymentMethods;
            this.publicKey = data.publicKey;
            this.dataid = data.dataid;
            if (!doNotSave) {
                this.saveToStorage();
            }
        },
        setSupportsDialog: function() {
            this.supportsDialog = true;
        },
        setViewport: function(viewport) {
            this.viewport = viewport;
        },
        updateData: function(data) {
            this.admin = !!data.admin;
            this.accountId = data.accountId || null;
            this.subscriptions = data.subscriptions;
            this.paymentMethods = data.paymentMethods;
            this.dataid = data.dataid;
            this.saveToStorage();
        },
        saveToStorage: function() {
            if (supportsSessionStorage) {
                console.log('saving: ' + this.dataid);
                // Should match setInitialData
                sessionStorage.setItem(storageKey, JSON.stringify({
                    countries: this.countries,
                    admin: this.admin,
                    accountId: this.accountId,
                    subscriptions: this.subscriptions,
                    paymentMethods: this.paymentMethods,
                    publicKey: this.publicKey,
                    dataid: this.dataid,
                }));
            }
        },
        loadFromStorage: function(dataid) {
            if (supportsSessionStorage && dataid) {
                var data = null;
                try {
                    data = JSON.parse(sessionStorage.getItem(storageKey));
                } catch { data = null; }

                console.log({
                    requested: dataid,
                    found: data?.dataid,
                    success: data?.dataid == dataid,
                });

                if (data && data.dataid == dataid) {
                    this.setInitialData(data, true);
                    return true;
                }
            }
        },
    },
});